export default "__VITE_ASSET__CWRwkU4V__"